import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { orderedDependentOptionsSelector, configuratorOptions } from '../../selectors/configurator';
import { selectSelectedCarpetChoice } from '../../selectors/pricing';

const useConfiguratorLoadFailure = () => {
  const dependentOptions = useSelector(orderedDependentOptionsSelector('SuperSku'));
  const configOptions = useSelector(configuratorOptions);
  const selectedChoice = useSelector(selectSelectedCarpetChoice);
  const [failedToLoad, setFailedToLoad] = useState(false);

  useEffect(() => {
    if (!isEmpty(configOptions) && !isEmpty(configOptions?.allIds)) {
      const condition = Object.values(configOptions).some((option) => {
        return dependentOptions.includes(option.id) && isEmpty(option.choices);
      });
      setFailedToLoad(condition);
    }
    if (!isEmpty(selectedChoice)) {
      setFailedToLoad(selectedChoice?.priceSquareFoot <= 0);
    }
  }, [configOptions, dependentOptions]);

  return failedToLoad;
};

export default useConfiguratorLoadFailure;
